export const namespaced = true;
const defaultData = {
    orderData: {
        addresses: {
            insuredPersonAddress: {
                firstName: '',
                lastName: '',
                street: '',
                postcode: '',
                city: '',
                email: '',
                phone: ''
            },
            shippingAddress: {
                firstName: '',
                lastName: '',
                street: '',
                postcode: '',
                city: '',
            }
        },
        differentShippingAddress: false,
        degreeOfCare: 1,
        deliveryIntervalDate: '',
        deliveryInterval: 'monatlich',
        comment: '',
        insuranceCompany: '',
        insuranceCompanyLater: false,
        insuranceNumber: '',
        insuranceNumberLater: false,
        birthday: ''
    }
};

export const state = () => (defaultData);


export const getters = {
    getOrderData: state => state.orderData,
}

export const mutations = {
    mutateOrderData(state, orderData) {
        state.orderData = orderData
    }
};

export const actions = {
    setOrderData({commit}, orderData) {
        return new Promise((resolve, reject) => {
            commit('mutateOrderData', orderData);
            resolve()
        })
    },
    resetData({commit}) {

        return new Promise((resolve, reject) => {
            commit('mutateOrderData', defaultData);
            resolve()
        })
    }
};

